import {fromJS, Map} from 'immutable';
import playrateActions from '../../actions/fortnite-game/playrate.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
export interface PlayrateState {
    data: {[key: string]: {[key: string]: string[]}};
    loading: boolean;
    lastFetch: Date;
    error?: string;
}

export const DEFAULT_STATE = fromJS({
    data: [],
    wau: 0,
    lastFetch: Date.now(),
    loading: false,
    error: undefined
});

export const playrateReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {data, silent = false, error} = action.payload || {};

    switch (action.type) {
        case playrateActions.TYPES.GET_PLAYRATE: {
            return state.merge({
                error: undefined,
                loading: !silent
            });
        }

        case playrateActions.TYPES.GET_PLAYRATE_COMPLETE: {
            return state.merge({
                data,
                lastFetch: Date.now(),
                loading: false,
                error
            });
        }

        case playrateActions.TYPES.GET_PLAYRATE_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('playrate', playrateReducer);
